import { render } from "./BuilderRequestMessageSendModal.vue?vue&type=template&id=6023baf4&scoped=true&ts=true&lang=pug"
import script from "./BuilderRequestMessageSendModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderRequestMessageSendModal.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderRequestMessageSendModal.vue?vue&type=style&index=0&id=6023baf4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6023baf4"]])

export default __exports__